class ReturnDeletedProduct {
    constructor() {
        this.init();
    }

    init() {
        this.returnProduct();
        document.addEventListener('addedBasketItem', (e) => {
            this.returnProduct();
        });

    }

    returnProduct() {
        const returnLinks = document.querySelectorAll('[data-return-product-link]:not([data-initialized="true"])');
        console.log(returnLinks)
        returnLinks.forEach((returnLink) => {
            returnLink.dataset.initialized = "true";
            const productId = returnLink.dataset.productId;
            const returnLinkParentElement = returnLink.parentElement;
            const basketItem = returnLinkParentElement.parentElement.querySelector('[data-basket-item]');
            const countInput = basketItem.querySelector('[data-basket-count]');


            returnLink.addEventListener('click', (e) => {
                const returnLinkWrap = returnLink.parentElement;
                const quantity = countInput.value;
                returnLinkWrap.classList.remove('_visible');

                document.dispatchEvent(new CustomEvent('add-basket-item', {detail: { productId, quantity, notNew: true }}));

                basketItem.classList.remove('_deleted');
            });
        })
    }
}

document.addEventListener('DOMContentLoaded', (e) => new ReturnDeletedProduct());